import React from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import PropTypes from 'prop-types';

const FSBModal = (props) => {
  const {
    toggleAlert,
    onConfirmClick,
    onClose,
    children,
    open = false,
    isModalFooter = false,
    confirmButtonLabel = 'Okay',
    closeButtonLabel = 'Close,',
    title = 'Your Modal Title',
    message = 'Please add your message here',
    modalClass = '',
    ...rest
  } = props;
  return (
    <Modal
      centered
      isOpen={open}
      toggle={toggleAlert}
      className={modalClass}
      {...rest}
    >
      <ModalHeader toggle={onClose}>{title}</ModalHeader>
      <ModalBody>{message || children}</ModalBody>
      {isModalFooter && (
        <ModalFooter>
          {closeButtonLabel && (
            <Button color="secondary " onClick={onClose}>
              {closeButtonLabel}
            </Button>
          )}
          {confirmButtonLabel && (
            <Button color="primary" onClick={onConfirmClick}>
              {confirmButtonLabel}
            </Button>
          )}
        </ModalFooter>
      )}
    </Modal>
  );
};
FSBModal.propTypes = {
  open: PropTypes.any,
  isModalFooter: PropTypes.bool,
  confirmButtonLabel: PropTypes.string,
  closeButtonLabel: PropTypes.string,
  title: PropTypes.node,
  message: PropTypes.string,
  onConfirmClick: PropTypes.func,
  onClose: PropTypes.func,
  toggleAlert: PropTypes.func,
  modalClass: PropTypes.string,
};
export default FSBModal;
